import { render, staticRenderFns } from "./DailyReportsHeader.vue?vue&type=template&id=4e56f681&"
import script from "./DailyReportsHeader.vue?vue&type=script&lang=js&"
export * from "./DailyReportsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports